module.exports = __webpack_public_path__ + "static/media/gray-cross.5df2dbe9.svg";